import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Layout from "./Layout/Layout";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: "admin" | "proponente";
}

export function ProtectedRoute({
  children,
  requiredRole,
}: ProtectedRouteProps) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  // Enquanto estiver carregando, mostra tela em branco ou loading
  if (loading) {
    console.log("⏳ [ProtectedRoute] Carregando...");
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 text-lg">
            Verificando autenticação...
          </p>
        </div>
      </div>
    );
  }

  // Se não está autenticado, redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se tem role obrigatório e o usuário não tem o role correto
  if (requiredRole && user?.tipo_usuario !== requiredRole) {
    // Redireciona cada tipo de usuário para sua página inicial correta
    const redirectPath =
      user?.tipo_usuario === "admin" ? "/admin/home" : "/home";
    return <Navigate to={redirectPath} replace />;
  }

  if (
    user?.tipo_usuario === "proponente" &&
    user.has_proponente === false &&
    location.pathname !== "/completar-cadastro"
  ) {
    return <Navigate to="/completar-cadastro" replace />;
  }

  if (
    location.pathname === "/completar-cadastro" &&
    user?.tipo_usuario === "proponente" &&
    user.has_proponente === true
  ) {
    return <Navigate to="/home" replace />;
  }

  // Se está tudo certo, renderiza com Layout
  return <Layout>{children}</Layout>;
}
